import axios from 'axios';
import { baseUrl } from '../utils/config';

export interface GpaiReviewPayload {
  doctor_id: string;
  test_start_date: string;
  test_end_date: string;
  qa_json: string;
  initial_diagnosis: string;
  initial_approval: boolean;
  initial_feedback: string;
  triage: string;
  triage_approval: boolean;
  triage_feedback: string;
  meds_recommendation: string;
  model_version: string;
}

export interface DaiReviewPayload {
  doctor_id: string;
  test_start_date: string;
  test_end_date: string;
  qa_json: string;
  initial_diagnosis: string;
  initial_approval: boolean;
  initial_feedback: string;
  diagnosis_image_url: string;
  final_diagnosis: string;
  final_approval: boolean;
  final_feedback: string;
}

const api = axios.create({ baseURL: baseUrl });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers = config.headers || {};
    (config.headers as any).Authorization = `Bearer ${token}`;
  }
  return config;
});

export const DrModelTestingService = {
  async getAllGpaiReviews(skip = 0, limit = 10) {
    try {
      const response = await api.get(`/gpai_reviews`, {
        params: { skip, limit },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching GPAI reviews:', error);
      throw error;
    }
  },

  async createGpaiReview(data: GpaiReviewPayload) {
    try {
      const response = await api.post(`/gpai_reviews`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating GPAI review:', error);
      throw error;
    }
  },

  async getAllDaiReviews(skip = 0, limit = 10) {
    try {
      const response = await api.get(`/dai_reviews`, {
        params: { skip, limit },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching DAI reviews:', error);
      throw error;
    }
  },

  async createDaiReview(data: DaiReviewPayload) {
    try {
      const response = await api.post(`/dai_reviews`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating DAI review:', error);
      throw error;
    }
  },

  async getDaiReviewStats() {
    try {
      const response = await api.get(`/dai_review_stats`);
      return response.data;
    } catch (error: unknown) {
      console.error('Error fetching DAI review stats:', error);
      if (typeof error === 'object' && error !== null) {
        const err = error as { response?: any; request?: any; message?: string };
        if (err.response) {
          // The request was made and the server responded with a status code
          console.error('Response data:', err.response.data);
          console.error('Response status:', err.response.status);
          console.error('Response headers:', err.response.headers);
        } else if (err.request) {
          // The request was made but no response was received
          console.error('No response received:', err.request);
        } else if (err.message) {
          // Something happened in setting up the request
          console.error('Error setting up request:', err.message);
        } else {
          console.error('Unknown error object:', err);
        }
      } else {
        console.error('Unknown error:', error);
      }
      throw error;
    }
  },

  async getGpaiReviewStats() {
    try {
      const response = await api.get(`/gpai_review_stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching GPAI review stats:', error);
      throw error;
    }
  },
};
